{
  "0a426a7cf7035aba": "Can't find what you're looking for?",
  "0cf8e2a03758919e": "Help by topic",
  "1174e465a7c77f38": "Loading Help Center",
  "21e344a9d52f4984": "Reach support directly and we'll help you right away.",
  "2217586c67cc8dd5": "Open the full support library.",
  "2dd25cabbad6c9c2": "Dedicated contacts",
  "4cc03b1d39867d97": "Open Help Center",
  "4f6bbf0f453c2c4f": "Download our mobile app to manage your schedule, post shifts, and message your workers on the go.",
  "617630ea4d370ebc": "Search for articles...",
  "6b491c7346cc1fdd": "Submit a request",
  "7b1c58a64d814c47": "Call 24/7 support",
  "7b56e0d0b308abe4": "How can we help?",
  "88caafee4e66991a": "Talk to support any time.",
  "8f0e6ece108b7b9c": "Choose a topic below to find answers and instructions.",
  "917e144e4bc3da89": "Submit request",
  "a0ccee4b426b3aa7": "Error loading support articles.",
  "a60530deb3fa0a97": "Billing Rep",
  "a7156767610022e1": "No support articles match your current search.",
  "a78cebc44214256b": "Help Center",
  "cb51da6d9dfab99d": "Browse all articles",
  "ccc498b77ae62cf8": "Account Manager",
  "d6e0a09ea9a50e52": "Opening Help Center…",
  "d86f74b180c59e24": "Call support",
  "d968ef24f7787160": "Scan to download",
  "d9db9c736ed99c3f": "Get answers about managing shifts, coordinating workers, and troubleshooting your account.",
  "dd1ffc861bb9cd27": "Your dedicated Clipboard Health team members.",
  "e09e173ffdea2f37": "Reach out to support directly and we'll help you right away.",
  "e28362912cdcde21": "No support articles are available right now.",
  "efd29d8c54d0a8ff": "Take Clipboard with you",
  "fc1c61ecc2038c73": "Send details and we'll follow up."
}
